/**
 * Iter 43 — Dynamic Branding Engine.
 *
 * Four brand themes, one shape. Each brand supplies its accent color,
 * a wordmark label (used until the real logo asset is provided), and
 * optional gradient hex pairs for cinematic gradients.
 *
 * Whiplash is the default and matches the existing app palette exactly
 * (var(--brand-accent) amber, zinc-950 body) so users bound to `brand=whiplash` see
 * no visual change vs. before Iter 43.
 */

export const BRANDS = {
  whiplash: {
    id: "whiplash",
    name: "Whiplash Film & Creative",
    short: "Whiplash",
    accent: "#f59e0b",
    accentSoft: "rgba(245, 158, 11, 0.15)",
    gradientFrom: "#f59e0b",
    gradientTo: "#c2830a",
    logoUrl: "https://customer-assets.emergentagent.com/job_video-tagging-lab/artifacts/we05yb1x_WC%20Logo%202018%20Outlined_White.png",
    wordmark: "WHIPLASH",
  },
  quad: {
    id: "quad",
    name: "Quad",
    short: "Quad",
    accent: "#00A7B5",
    accentSoft: "rgba(0, 167, 181, 0.15)",
    gradientFrom: "#00A7B5",
    gradientTo: "#00747E",
    logoUrl: "https://customer-assets-v7afamib.emergentagent.net/job_video-tagging-lab/artifacts/sr3aruek_Logo-QuadFullLockup-BW.png",
    wordmark: "QUAD",
  },
  bsn: {
    id: "bsn",
    name: "BSN Sports",
    short: "BSN Sports",
    accent: "#DC2626",
    accentSoft: "rgba(220, 38, 38, 0.15)",
    gradientFrom: "#DC2626",
    gradientTo: "#991B1B",
    logoUrl: "https://customer-assets-v7afamib.emergentagent.net/job_video-tagging-lab/artifacts/swkjmcmd_BSN_logo_Underneath_1color_White_Vertical.png",
    wordmark: "BSN SPORTS",
  },
  bps: {
    id: "bps",
    name: "Bass Pro Shops CLUB",
    short: "Bass Pro Shops CLUB",
    accent: "#e2a746",
    accentSoft: "rgba(226, 167, 70, 0.15)",
    gradientFrom: "#e2a746",
    gradientTo: "#a97929",
    logoUrl: "https://customer-assets-v7afamib.emergentagent.net/job_video-tagging-lab/artifacts/z6gk6j9j_BassProCLUB_Logo.png",
    wordmark: "Bass Pro Shops CLUB",
  },
  stream: {
    id: "stream",
    name: "Stream Realty",
    short: "Stream Realty",
    accent: "#3f5e8a",
    accentSoft: "rgba(63, 94, 138, 0.15)",
    gradientFrom: "#3f5e8a",
    gradientTo: "#2c4262",
    logoUrl: "https://customer-assets-v7afamib.emergentagent.net/job_video-tagging-lab/artifacts/99918f347d1193e4_Stream%20logo_white.png",
    wordmark: "STREAM REALTY",
  },
};

export const DEFAULT_BRAND = "whiplash";

export function resolveBrand(brandId) {
  return BRANDS[brandId] || BRANDS[DEFAULT_BRAND];
}
